import React, { useState } from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'

// Layouts
import Header from './layouts/Header'
import Footer from './layouts/Footer'

// Pages
import Home from './pages/Home'
import Error from './pages/Error'
import MySpace from './pages/MySpace'

// Mdl contact
import Contact from './components/Contact'

import './App.css'

import background_img from './assets/img/background_webp.webp'

function App() {
    const [showMdlContact, setShowMdlContact] = useState(false);

    return (
        <React.StrictMode>
            <Router>
                <Header setShowMdlContact={setShowMdlContact} />

                {showMdlContact && <Contact setShowMdlContact={setShowMdlContact} />}

                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="*" element={<Error />} />
                    <Route path="/mySpace" element={<MySpace />} />
                </Routes>

                <Footer />

                <img className='background_img' src={background_img} alt=" " />
            </Router>
        </React.StrictMode>
    )
}

export default App;